module.exports = __webpack_public_path__ + "static/media/FFEP_221104.ff4396b1.jpg";